import { MyNaviOpenCampusItem } from '@/components/Campaign/mynavi/MyNaviModels/College/MyNaviOpenCampusItem'
import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import type { MynaviCollegeDetailResponse } from '@/schemas/v2/mynavi'
import { IconChevronLeft } from '@tabler/icons-react'

export type MyNaviCollegeDetailProps = {
  college: MynaviCollegeDetailResponse
  /** OC の isWished 状態マップ (ocId → boolean) */
  isWishedMap: Record<number, boolean>
  onBack: () => void
  onBrochureRequest: () => void
  onEventInfo: () => void
  onToggleWanted: (ocId: number) => void
}

export const MyNaviCollegeDetail = ({
  college,
  isWishedMap,
  onBack,
  onBrochureRequest,
  onEventInfo,
  onToggleWanted,
}: MyNaviCollegeDetailProps) => {
  return (
    <div className="bg-[#fbfbfb] min-h-screen">
      {/* ヘッダー */}
      <div className="bg-[#fbfbfb] flex items-center h-[42px] px-2">
        <button type="button" className="flex items-center gap-1" onClick={onBack}>
          <IconChevronLeft size={24} color="#000" stroke={1.5} />
          <MyNaviTypography variant="back-label" className="leading-none">
            戻る
          </MyNaviTypography>
        </button>
      </div>

      {/* 画像 */}

      {college.imageUrl && (
        <div className="w-full h-[234px] bg-[#d9d9d9] overflow-hidden">
          <img src={college.imageUrl} alt={college.name} className="w-full h-full object-cover" />
        </div>
      )}

      {/* 大学情報 */}
      <div className="px-4 mt-[19px]">
        <MyNaviTypography variant="college-name" className="mb-1">
          {college.name}
        </MyNaviTypography>
        <MyNaviTypography variant="tiny" as="p" className="mt-1">
          {college.collegeType}
          {college.collegeType && college.prefecture ? '　' : ''}
          {college.prefecture}
        </MyNaviTypography>
      </div>

      {/* ボタン行 */}
      <div className="flex gap-[18px] px-3 mt-[19px]">
        <button
          type="button"
          onClick={onBrochureRequest}
          disabled={!college.brochureUrl}
          className="flex-1 h-[36px] rounded-[5px] text-white text-[12px] disabled:opacity-40"
          style={{ backgroundColor: '#E69F67', fontFamily: "'BIZ UDPGothic', sans-serif" }}
        >
          資料請求
        </button>
        <button
          type="button"
          onClick={onEventInfo}
          disabled={!college.openCampusUrl}
          className="flex-1 h-[36px] rounded-[5px] text-white text-[12px] disabled:opacity-40"
          style={{ backgroundColor: '#73BDB0', fontFamily: "'BIZ UDPGothic', sans-serif" }}
        >
          イベント情報
        </button>
      </div>

      {/* 説明テキスト */}
      {college.description && (
        <MyNaviTypography variant="caption" as="p" className="leading-[1.5] mx-4 mt-[17px]">
          {college.description}
        </MyNaviTypography>
      )}

      {/* OC 開催日程 */}
      {college.openCampuses.length > 0 && (
        <div className="mt-[43px]">
          <p
            style={{ fontFamily: "'BIZ UDPGothic', sans-serif" }}
            className="text-[20px] text-[#058bbe] ml-4 leading-[1.5]"
          >
            オープンキャンパス開催日程
          </p>
          <div className="flex flex-col">
            {college.openCampuses.map((oc) => {
              const detailUrl = oc.detailUrl
              return (
                <div key={oc.id} className={'mt-1'}>
                  <MyNaviOpenCampusItem
                    oc={oc}
                    isWished={isWishedMap[oc.id] ?? oc.isWished}
                    onToggleWanted={() => onToggleWanted(oc.id)}
                    onViewDetail={detailUrl ? () => window.open(detailUrl, '_blank', 'noopener,noreferrer') : undefined}
                  />
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
